import { createFileRoute, redirect } from '@tanstack/react-router';
import { getCurrentAuthorizeQuery } from '@/lib/oauth/oauth-flow';
import { OAuthConsentPage } from '@/pages/oauth/OAuthConsentPage';

export const Route = createFileRoute('/_oauth/oauth/consent')({
	beforeLoad: () => {
		const read = getCurrentAuthorizeQuery();
		if (read.kind === 'valid') return;
		throw redirect({
			to: '/oauth/error',
			search: { error: read.kind === 'expired' ? 'request_expired' : 'invalid_request' },
		});
	},
	component: OAuthConsentPage,
});
